/**
 * EliorGroup.Joyfood.B2B API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface B2BShopServiceDto { 
    id?: number;
    serviceId?: number;
    serviceTypeId?: number;
    serviceTypeName?: string | null;
    day?: number;
    openingHour?: string | null;
    closingHour?: string | null;
    orderCutoffHour?: string | null;
    orderCutoffDay?: number;
    shopId?: number;
    orderCutoffTimeZoneId?: string | null;
}

